import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Heading, Button, Stack, StackDivider, HStack, Spacer, Text } from '@chakra-ui/react';
import { ActiveScoutCensusSummaryForm } from './ActiveScoutCensusSummaryForm';
import {useApiProvider} from '../../../../../api/ApiProvider';
import ErrorMessage from '../../../../parts/ErrorMessage';
import { useAuth } from '../../../../../auth/AuthProvider';
import {summaryCensusTranslateKey} from "../../../../../utils/censusTranslateKey";
import {summaryAssignmentTranslateKey} from "../../../../../utils/AssignmentTranslateKey";

const ActiveScoutCensusSummary: React.FC = () => {
    const provider = useApiProvider();
    const navigate = useNavigate();
    const { user } = useAuth();

    const loc = useLocation();
    const data: ActiveScoutCensusSummaryForm = loc.state.data;
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [apiCallError, setApiCallError] = useState<string>("");
        
    const onSubmit = () => {

        setSubmitting(true);
        setApiCallError("");

        provider.postCensus({
            RegistrantId: user?.Id,
            Request: "czynny instruktor",
            RegistrantComment: data.comment,
            StateAwards: data.stateAwards,
            YPSCitizenship: data.ypsCitizenship,
            YPSResidence: data.ypsResidence,
            YPSAccept: data.ypsAccept,
            YPSKRKSent: data.ypsKRKSent,
            KRKIssueDate: data.krkIssueDate,
            Assignments: data.assignments?.map(item => {
                return {
                    IsMain: item.isMain,
                    Function: item.assignedFunction,
                    FunctionStartDate: item.startDate,
                    FunctionEndDate: item.endDate,
                    AdditionalInformation: item.additionalInformation,
                    Decree: item.decree,
                    Unit: item.unit,
                };
            })
        })
            .then(data => navigate("/"))
            .catch(err => setApiCallError(err))
            .finally(() => setSubmitting(false));
    };


    const onBack = () => {
        navigate('/scout-census', { state: { data: loc.state.data } })
    }

    return (
        <Box
            minHeight="100vh"
            width="100vw"
            backgroundImage="url('/images/forest.jpg')"
            backgroundSize="cover"
            backgroundPosition="center"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Box
                bg="white"
                padding="5"
                margin="8"
                borderRadius="md"
                boxShadow="lg"
                textAlign="left"
                width="500px"
                marginTop="120px"
            >
                <Heading
                    padding="3"
                    as="h2"
                    size="lg"
                    textAlign="center"
                >
                    Podsumowanie arkusza spisowego
                </Heading>

                <Heading p="5" as="h3" size="md" textAlign="start">
                    Dane ogólne
                </Heading>
                {data ? (
                    <Stack divider={<StackDivider />} spacing='4'>
                        {Object.entries(data)
                            .filter(([key, value]) => key !== 'assignments')
                            .map(([key, value]) => (
                                <Box>
                                    <Heading size='xs' textTransform='uppercase'>
                                        {summaryCensusTranslateKey[key] ? summaryCensusTranslateKey[key] : key}
                                    </Heading>
                                    <HStack>
                                        <Text pt='2' fontSize='sm'>{
                                            (value === "" || value === null) ? "brak danych" :
                                                (typeof value === "boolean") ? (value ? "zaakceptowano" : "niezaakceptowano") :
                                                    (key === "krkIssueDate") ? value.split('T')[0] : 
                                                        value}
                                        </Text>
                                        <Spacer />
                                    </HStack>
                                </Box>
                                
                            ))}
                        {Object.entries(data.assignments).map(([assignmentKey, assignmentValue]) => (
                            <Stack divider={<StackDivider />} spacing='4'>
                                {Object.entries(assignmentValue)
                                    .filter(([key, value]) => key !== 'unit')
                                    .map(([key, value]) => (
                                    <>
                                    {key === "isMain" ?
                                        <Heading p="5" as="h3" size="md" textAlign="start">
                                            {value ? "Główny przydział służbowy" : "Przydział służbowy"}
                                        </Heading>
                                        : <Box>
                                            <Heading size='xs' textTransform='uppercase'>
                                                {summaryAssignmentTranslateKey[key] ? summaryAssignmentTranslateKey[key] : key}
                                            </Heading>
                                            <HStack>
                                                <Text pt='2' fontSize='sm'>
                                                    {value === "" || value === null
                                                        ? "brak danych"
                                                        : typeof value === "string" && (key === "startDate" || key === "endDate")
                                                            ? value.split("T")[0]
                                                            : typeof value === "object"
                                                                ? JSON.stringify(value, null, 2)
                                                                : value}
                                                </Text>
                                                <Spacer />
                                            </HStack>
                                        </Box>}
                                    </>))}
                            </Stack>
                        ))}
                        <Spacer />
                    </Stack>
                ) : (
                    <Text pt='2' fontSize='sm' textTransform='uppercase'>
                        brak danych
                    </Text>
                )}

                <ErrorMessage text={apiCallError} />
                <Button width="full" colorScheme="brand" onClick={onSubmit} isLoading={submitting}>Zarejestruj</Button>
                <Button width="full" onClick={onBack}>Powrót</Button>
            </Box>
        </Box>
    );
};

export default ActiveScoutCensusSummary;